export default "__VITE_ASSET__KO0Cet0g__"